import getObjectKey from 'lib/object/getObjectKey'
import type { BurnBatchRequest } from './burnTypes'

function buildBurnKey(
  request: BurnBatchRequest,
  customerId: string,
): string {
  return getObjectKey({
    price: request.price,
    loyaltyProductType: request.loyaltyProductType,
    mx: request.mx,
    customerId,
    ...(request.currency ? { currency: request.currency } : undefined),
  })
}

export default buildBurnKey
